import styled from 'styled-components'

const BlogPostAnnounceHeaderLinkUi = styled.a`
  text-decoration: none;
  color: inherit;
`

export default BlogPostAnnounceHeaderLinkUi
